import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { DialogBox } from '@mummssoftware/common-ui';
import defaults from '../../translations/en.json';

type DrivingVisitExpiredModalProps = {
  open: boolean;
  onConfirm: () => void;
  confirming?: boolean;
};

export const DrivingVisitExpiredModal = ({
  open,
  onConfirm,
  confirming,
}: DrivingVisitExpiredModalProps) => (
  <DialogBox
    title={defaults.drivingVisitExpiredTitle}
    disableBackdropClick
    open={open}
    handleClick={() => null}
    noIcon
  >
    <Typography>{defaults.drivingVisitExpiredContent}</Typography>
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={onConfirm}
        disabled={!!confirming}
      >
        {defaults.ok}
      </Button>
    </div>
  </DialogBox>
);
